import { format, parse } from 'date-fns'
import { ru } from 'date-fns/locale'

import constants from '~/constants'
import helpers from '~/helpers'

function adjustForTimeZone (date: Date): Date {
  const offsetInMs = date.getTimezoneOffset() * 60000
  date.setTime(date.getTime() + offsetInMs)

  return date
}

function getDateTimeInMsk (dateTimeString: string): Date {
  const [datePart, timePart] = dateTimeString.split('T')
  const [year, month, day] = datePart.split('-').map(Number)
  const [hour, minute, second] = timePart.split(/[:+]/).map(Number)
  const utcTimestamp = Date.UTC(year, month - 1, day, hour, minute, second)
  const moscowTimestamp = utcTimestamp + 10800000 // 10800000 ms is 3 hours.

  return adjustForTimeZone(new Date(moscowTimestamp))
}

export default {
  formatCashback: (cashback: number | null): string => typeof cashback === 'number'
    ? String(Math.round(10000 * cashback) / 100).replace('.', ',')
    : '',
  formatDate (dateString: string): string {
    const { dateInput, dateOutput } = constants.dateTimeFormats

    return format(parse(dateString, dateOutput, new Date()), dateInput)
  },
  formatDateTime: (dateTimeString: string, formatString = constants.dateTimeFormats.dateTimeFull): string => format(
    getDateTimeInMsk(dateTimeString),
    formatString,
    { locale: ru }
  ),
  formatDistance: (distance: number): string => distance >= 1000
    ? `${(distance / 1000).toFixed(1).replace('.', ',')}\xA0км`
    : `${Math.round(distance)}\xA0м`,
  formatBadgeText (count: number | null): string | null {
    if (count === null) {
      return null
    }

    switch (true) {
      case count < 1e3:
        return String(count)
      case count >= 1e3 && count < 1e6:
        return `${Math.trunc(count / 1e3)}К`
      case count >= 1e6:
        return `${Math.trunc(count / 1e6)}М`
      default:
        return String(count)
    }
  },
  formatFileSize: (bytes: number, precision = 2): string => {
    if (bytes === 0) {
      return '0 б'
    }

    const base = 1024
    const postfixes = ['б', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ЙБ']
    const index = Math.floor(Math.log(bytes) / Math.log(base))

    return `${parseFloat((bytes / Math.pow(base, index)).toFixed(precision))} ${postfixes[index]}`
      .replace('.', ',')
  },
  formatFloatingPointNumber: (number: number): string => String(number).replace('.', ','),
  formatPrice (price: number | null, isInKopecks = false): string {
    if (isInKopecks) {
      price = helpers.convertKopecksToRubles(price)
    }

    if (typeof price !== 'number') {
      return ''
    }

    const parts = price.toString().split('.')
    const wholePartAsNumber = Number(parts[0])
    const wholePart = wholePartAsNumber >= 1000 && wholePartAsNumber <= 9999
      ? parts[0]
      : parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1\u202F')

    return parts.length === 1 ? wholePart : `${wholePart},${parts[1]}`
  }
}
